import Yoga from './Yoga'

export default Yoga
// eslint-disable-next-line import/export
export * from './Yoga'
